var React = require('react');

function ArrowGreyLightClose (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M118.305 12.946l10.216 10.255a.998.998 0 0 1 0 1.409.99.99 0 0 1-1.403 0l-10.217-10.255-10.216 10.255a.99.99 0 0 1-1.403 0 .998.998 0 0 1 0-1.409l10.216-10.255-10.216-10.254a.998.998 0 0 1 0-1.409.99.99 0 0 1 1.403 0l10.216 10.254 10.216-10.254a.99.99 0 0 1 1.404 0 1 1 0 0 1 0 1.409l-10.216 10.254z"}));
}

ArrowGreyLightClose.displayName = "ArrowGreyLightClose";

ArrowGreyLightClose.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ArrowGreyLightClose;

ArrowGreyLightClose.default = ArrowGreyLightClose;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/arrow-grey-light-close.svg
// module id = 1247
// module chunks = 0